// Builds & downloads a printable A-portrait referral poster PNG for a commission agent.
// Relies on a pre-rendered <QRCodeCanvas id={qrCanvasId} .../> already present in the DOM.

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export async function downloadReferralPoster({ qrCanvasId, agentName, code }) {
  const origin = window.location.origin;
  const W = 1080, H = 1350;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  const g = ctx.createLinearGradient(0, 0, 0, H);
  g.addColorStop(0, "#0f766e"); g.addColorStop(1, "#065f46");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  ctx.textAlign = "center";

  // logo card
  roundRect(ctx, W / 2 - 150, 55, 300, 140, 26); ctx.fillStyle = "#ffffff"; ctx.fill();
  const logo = new Image(); logo.src = "/rani-logo.png";
  try { await logo.decode(); } catch (e) { console.warn("poster logo load failed", e); }
  if (logo.naturalWidth) {
    const r = Math.min(250 / logo.naturalWidth, 108 / logo.naturalHeight);
    const lw = logo.naturalWidth * r, lh = logo.naturalHeight * r;
    ctx.drawImage(logo, W / 2 - lw / 2, 55 + (140 - lh) / 2, lw, lh);
  }

  ctx.fillStyle = "#ffffff"; ctx.font = "800 60px Arial";
  ctx.fillText("Rani Super Market", W / 2, 285);
  ctx.fillStyle = "#99f6e4"; ctx.font = "700 30px Arial";
  ctx.fillText("REFERRAL PARTNER", W / 2, 330);
  ctx.fillStyle = "#ffffff"; ctx.font = "800 46px Arial";
  ctx.fillText(agentName || "Agent", W / 2, 392);

  // QR card
  roundRect(ctx, 240, 430, 600, 600, 36); ctx.fillStyle = "#ffffff"; ctx.fill();
  const qr = document.getElementById(qrCanvasId);
  if (qr) ctx.drawImage(qr, 240 + 70, 430 + 45, 460, 460);
  ctx.fillStyle = "#065f46"; ctx.font = "800 40px Arial";
  ctx.fillText("Scan & Shop Online", W / 2, 430 + 560);

  // code pill
  roundRect(ctx, W / 2 - 240, 1068, 480, 84, 42); ctx.fillStyle = "#facc15"; ctx.fill();
  ctx.fillStyle = "#064e3b"; ctx.font = "700 26px Arial";
  ctx.fillText("REFERRAL CODE", W / 2, 1100);
  ctx.font = "900 40px Arial";
  ctx.fillText(code, W / 2, 1140);

  // caption + url
  ctx.fillStyle = "#ffffff"; ctx.font = "600 31px Arial";
  ctx.fillText("Is QR se order karein aur", W / 2, 1210);
  ctx.fillText(`${agentName || "hamare agent"} ko support karein`, W / 2, 1252);
  ctx.fillStyle = "#99f6e4"; ctx.font = "700 28px Arial";
  ctx.fillText(origin.replace(/^https?:\/\//, ""), W / 2, 1305);

  await new Promise((resolve) => c.toBlob((blob) => {
    if (blob) {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `referral-${code}.png`;
      a.click();
      URL.revokeObjectURL(a.href);
    }
    resolve();
  }, "image/png"));
}
